import styled from "styled-components";
import { COLORS } from "@/react/theme/constants";
import Tooltip from "@8x8/oxygen-tooltip";

const StyledMessage = styled.div`
  color: ${COLORS.danger};
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ErrorMessage = ({ message }) => {
  if (!message) return null;
  return (
    <Tooltip title={message}>
      <StyledMessage>{message}</StyledMessage>{" "}
    </Tooltip>
  );
};
